import { ToothStateEnum } from "requests";

const CAT_ADULT_TEETH_1 = [101, 102, 103, 104, 106, 107, 108, 109];
const CAT_ADULT_TEETH_2 = [201, 202, 203, 204, 206, 207, 208, 209];
const CAT_ADULT_TEETH_3 = [301, 302, 303, 304, 307, 308, 309];
const CAT_ADULT_TEETH_4 = [401, 402, 403, 404, 407, 408, 409];

export const CAT_ADULT_TEETH = {
  1: CAT_ADULT_TEETH_1,
  2: CAT_ADULT_TEETH_2,
  3: CAT_ADULT_TEETH_3,
  4: CAT_ADULT_TEETH_4
};

const CAT_MILK_TEETH_1 = [501, 502, 503, 504, 506, 507, 508];
const CAT_MILK_TEETH_2 = [601, 602, 603, 604, 606, 607, 608];
const CAT_MILK_TEETH_3 = [701, 702, 703, 704, 707, 708];
const CAT_MILK_TEETH_4 = [801, 802, 803, 804, 807, 808];

export const CAT_MILK_TEETH = {
  1: CAT_MILK_TEETH_1,
  2: CAT_MILK_TEETH_2,
  3: CAT_MILK_TEETH_3,
  4: CAT_MILK_TEETH_4
};

const DOG_ADULT_TEETH_1 = [101, 102, 103, 104, 105, 106, 107, 108, 109, 110];
const DOG_ADULT_TEETH_2 = [201, 202, 203, 204, 205, 206, 207, 208, 209, 210];
const DOG_ADULT_TEETH_3 = [
  301,
  302,
  303,
  304,
  305,
  306,
  307,
  308,
  309,
  310,
  311
];
const DOG_ADULT_TEETH_4 = [
  401,
  402,
  403,
  404,
  405,
  406,
  407,
  408,
  409,
  410,
  411
];

export const DOG_ADULT_TEETH = {
  1: DOG_ADULT_TEETH_1,
  2: DOG_ADULT_TEETH_2,
  3: DOG_ADULT_TEETH_3,
  4: DOG_ADULT_TEETH_4
};

const DOG_MILK_TEETH_1 = [501, 502, 503, 504, 506, 507, 508];
const DOG_MILK_TEETH_2 = [601, 602, 603, 604, 606, 607, 608];
const DOG_MILK_TEETH_3 = [701, 702, 703, 704, 706, 707, 708];
const DOG_MILK_TEETH_4 = [801, 802, 803, 804, 806, 807, 808];

export const DOG_MILK_TEETH = {
  1: DOG_MILK_TEETH_1,
  2: DOG_MILK_TEETH_2,
  3: DOG_MILK_TEETH_3,
  4: DOG_MILK_TEETH_4
};

const RABBIT_TEETH_1 = [101, 102, 106, 107, 108, 109, 110, 111];
const RABBIT_TEETH_2 = [201, 202, 206, 207, 208, 209, 210, 211];
const RABBIT_TEETH_3 = [301, 307, 308, 309, 310, 311];
const RABBIT_TEETH_4 = [401, 407, 408, 409, 410, 411];

export const RABBIT_TEETH = {
  1: RABBIT_TEETH_1,
  2: RABBIT_TEETH_2,
  3: RABBIT_TEETH_3,
  4: RABBIT_TEETH_4
};

export const TOOTH_STATE_TO_COLOR: Record<string, string> = {
  [ToothStateEnum.Untreated]: "#62CD6D",
  [ToothStateEnum.Abnormal]: "#ED8936",
  [ToothStateEnum.Missing]: "#93A1AB",
  [ToothStateEnum.Extracted]: "#EC7474",
  [ToothStateEnum.Treated]: "#A8A0FF",
  [ToothStateEnum.Unerupted]: "#EB67CE"
};

export const TOOTH_STATE_TO_BORDER: Record<string, string> = {
  [ToothStateEnum.Untreated]: "#4C9A54",
  [ToothStateEnum.Abnormal]: "#AD6E10",
  [ToothStateEnum.Missing]: "#93A1AB",
  [ToothStateEnum.Extracted]: "#9C4848",
  [ToothStateEnum.Treated]: "#7E52A0",
  [ToothStateEnum.Unerupted]: "#AA336A"
};
